import moment from "moment";
import { BUTTON_TYPE, Icons } from "prefab";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { FORM_FIELD_TYPE } from "../../../../constants";
import styles from "../../../../styles/Campaigns/PauseOrResumeActions.module.scss";
import Form from "../../../common/Form";
import RightPanel from "../../../common/RightPanel";

const { InfoFilledIcon } = Icons;

export default class MoveCampaigns extends Component {
  state = {
    fromDate: this.props.fromDate,
    hasError: false,
  };

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    moveCampaigns: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
  };

  static defaultProps = {
    fromDate: null,
    selectionInfo: null,
  };

  componentWillUnmount = () => {
    this.closeAction();
  };

  closeAction = () => {
    this.setState({
      fromDate: null,
      hasError: false,
    });
    this.props.onClose();
  };

  save = (duration) => {
    // Moved fromDate
    const { fromDate } = this.state;
    //Validation to check if fromDate is entered
    if (!fromDate || moment(fromDate).isBefore(moment(), "day")) {
      this.setState({ hasError: true });
      return;
    }
    // Moved toDate
    const toDate = this.addDaysToDate(fromDate, duration);
    this.props.moveCampaigns({ fromDate, toDate });
  };

  findDuration(startDate, endDate) {
    if (!startDate || !endDate) return 0;
    // Parse the dates using Moment.js
    const start = moment(startDate);
    const end = moment(endDate);
    // return the difference in days
    return end.diff(start, "days");
  }

  addDaysToDate(date, days) {
    // Parse the date using Moment.js
    const momentDate = moment(date);
    // Add the days to the date
    momentDate.add(days, "days");
    // Return the new date
    return momentDate.format("YYYY-MM-DDTHH:mm:ss[Z]");
  }

  getComputedEndDate = (fromDate, duration) => {
    if (!fromDate) return null;
    return moment(this.addDaysToDate(fromDate, duration)).format("DD MMM YYYY");
  };

  formatDate = (date) => (date ? moment.utc(date).format("DD MMM YYYY") : "-");

  subtractDaysFromDate(date, days) {
    // Parse the date using Moment.js
    const momentDate = moment(date);
    // Subtract the days from the date
    momentDate.subtract(days, "days");
    // Return the new date
    return momentDate;
  }

  render = () => {
    const { isOpen, header, selected, item, parentValidity } = this.props;
    const { fromDate, hasError } = this.state;

    //!Date Range Validation
    //parentValidity: Tg Validity for media, Campaign Validity for Tg, undefined for campaign
    const parentStartDate = parentValidity ? parentValidity?.fromDate : undefined;
    const parentEndDate = parentValidity ? parentValidity?.toDate : undefined;

    const today = moment();
    //duration = endDate - startDate
    const duration = this.findDuration(selected[0]?.validity.fromDate, selected[0].validity.toDate);
    //date range: {from:max(parentStartDate,today) , to:(parentEndDate - duration)}
    const minDate = parentStartDate
      ? moment.max(moment(parentStartDate), today).toDate()
      : today.toDate();
    const maxDate = parentEndDate
      ? this.subtractDaysFromDate(parentEndDate, duration).toDate()
      : undefined;
    const computedEndDate = this.getComputedEndDate(fromDate, duration);
    const isCampaignMove = item === "campaign";
    const campaign = selected[0] || {};
    const campaignValidity = campaign.validity || {};
    const totalDuration = duration + 1;
    const currentValidity = `${this.formatDate(campaignValidity.fromDate)} - ${this.formatDate(
      campaignValidity.toDate
    )}`;

    return (
      <RightPanel
        isOpen={isOpen}
        onClose={() => this.closeAction()}
        header={isCampaignMove ? "RightPanelHeader.moveCampaign" : header}
        className={isCampaignMove ? styles.movePanel : undefined}
        showFooter={true}
        primaryButtonProps={[
          {
            text: isCampaignMove ? "Button.moveCampaign" : "Button.move",
            buttonType: BUTTON_TYPE.PRIMARY,
            onClick: () => this.save(duration),
          },
        ]}
        secondaryButtonProps={{ text: "Button.close", onClick: this.closeAction }}
      >
        {isCampaignMove && (
          <div className={styles.moveSummary}>
            <div className={styles.summaryField}>
              <div className={styles.summaryLabel}>Campaign Name &amp; ID</div>
              <div className={styles.summaryValue}>
                {campaign.name || "-"} ({campaign.id ? campaign.id.slice(0, 6) : "-"})
              </div>
            </div>
            <div className={styles.summaryField}>
              <div className={styles.summaryLabel}>Current Validity</div>
              <div className={styles.summaryValue}>{currentValidity}</div>
            </div>
            <div className={styles.summaryField}>
              <div className={styles.summaryLabel}>Total Duration</div>
              <div className={styles.summaryValue}>{totalDuration} Days</div>
            </div>
          </div>
        )}
        <div className={isCampaignMove ? styles.moveDateRow : undefined}>
          <Form
            config={[
              {
                type: FORM_FIELD_TYPE.DATE,
                title: "New Start Date",
                invalidDateMessage: "Invalid To Date",
                onChange: (v) => {
                  this.setState({ fromDate: moment(v).format("YYYY-MM-DDTHH:mm:ss[Z]") });
                },
                value: fromDate ? new Date(fromDate) : null,
                placeholder: "MM/DD/YYYY",
                error: hasError,
                errorMessage: "Select today or a future date",
                minDate: minDate,
                maxDate: maxDate,
                disabled: Boolean(maxDate && minDate > maxDate),
                defaultValue: minDate,
              },
            ]}
          />
          {isCampaignMove && (
            <div className={styles.newEndDate}>
              <div className={styles.dateLabel}>New End Date</div>
              <div className={styles.dateValue}>{computedEndDate || "-"}</div>
            </div>
          )}
        </div>
        {isCampaignMove ? (
          <div className={styles.moveWarning}>
            <InfoFilledIcon />
            <span>
              The campaign validity and associated medias will be moved based on the new start date
              selected above.
            </span>
          </div>
        ) : (
          <div className={styles.campaignActionInfo}>
            <span>
              The {item.replace("_", " ")} start date will be readjusted to align with the selected
              date above.
            </span>
          </div>
        )}
      </RightPanel>
    );
  };
}
